import { useInterval } from 'usehooks-ts';
import { DataTestId } from '@mews-commander/enums';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { NewRelicEventType } from '@mews/enums';
import { COUNT_DOM_ELEMENTS_INTERVAL, countDomElements } from '@optimus-web/helpers';
import { reportNewRelicEvents } from '../../../modules/app/actions/newRelic';

export const useDesignSystemAdoptionMeasurement = () => {
    const dispatch = useCommanderThunkDispatch();
    useInterval(() => {
        const elementCount = countDomElements({
            exclude: `[data-test-id="${DataTestId.AppNavbar}"] *, [data-test-appsidebar] *`,
        });
        if (elementCount.measurementSuccessful) {
            dispatch(
                reportNewRelicEvents([
                    {
                        totalElements: elementCount.totalElements,
                        mdsElements: elementCount.mdsElements,
                        adoptionPercentage: elementCount.adoptionPercentage,
                        eventType: NewRelicEventType.DesignSystemAdoption,
                    },
                ])
            );
        }
    }, COUNT_DOM_ELEMENTS_INTERVAL);
};
